import I18n from 'I18n';
export const getDisabledMessagingFromTranscription = transcriptionStatus => {
  switch (transcriptionStatus) {
    case 'TRANSCRIPT_TOO_SHORT':
      return {
        disabledSubtitle: I18n.text('call-summary.copilot.transcriptTooShortTitle'),
        disabledDescription: I18n.text('call-summary.copilot.transcriptTooShortDescription')
      };
      break;
    case 'TRANSCRIPT_PROCESSING':
    case null:
      return {
        disabledSubtitle: I18n.text('call-summary.copilot.loadingTitle'),
        disabledDescription: I18n.text('call-summary.copilot.loadingDescription')
      };
      break;
    default:
      return {
        disabledSubtitle: I18n.text('call-summary.copilot.noTranscriptAvailableTitle'),
        disabledDescription: I18n.text('call-summary.copilot.noTranscriptAvailableDescription')
      };
      break;
  }
};